import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import CustomVoices from '../components/CustomVoices';
import PlanCreditsDisplay from '../components/PlanCreditsDisplay';
import LanguageSwitcher from '../components/LanguageSwitcher';
import CUSTOM_VOICES_COPY from '../locales/customVoices';

export default function CustomVoicesPage() {
  const router = useRouter();
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { language } = useLanguage();
  const t = (CUSTOM_VOICES_COPY[language] || CUSTOM_VOICES_COPY.en).page;

  // Custom Voices is open to every authenticated user; tier-specific
  // gating (credit availability, paid-tier checks) is handled inside
  // the enrollment wizard itself.
  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      router.push({
        pathname: '/login',
        query: { redirect: router.asPath }
      });
    }
  }, [isAuthenticated, authLoading, router]);

  // Show loading spinner while checking authentication
  if (!isAuthenticated || authLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col overscroll-behavior-none" style={{ touchAction: 'manipulation' }}>
      {/* Header - scrolls with content on mobile */}
      <div className="border-b border-gray-400 dark:border-dark-border bg-gray-200 dark:bg-dark-card shadow-md relative">
        <LanguageSwitcher variant="below-header" />
        <div className="px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
            <div className="flex-1">
              <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">{t.title}</h1>
              <p className="text-xs sm:text-sm text-gray-700 dark:text-gray-400 mt-1">
                {t.subtitle}
              </p>
            </div>
            <div className="self-center sm:self-auto">
              <PlanCreditsDisplay />
            </div>
          </div>
        </div>
      </div>

      {/* Main content area */}
      <div className="flex-1 bg-gray-50 dark:bg-dark-bg overscroll-behavior-none">
        <CustomVoices />
      </div>
    </div>
  );
}
